import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: '50px',
    marginLeft: '20px',
  },
  path: {
    fill: '#FFFFFF',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      id="logosandtypes_com"
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
    >
      <defs id="defs1">
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="100"
          height="100"
          filterUnits="userSpaceOnUse"
          style={{
            colorInterpolation: "sRGB",
          }}
        >
          <feColorMatrix
            values="10 0.72 10 0 0 10 0.72 10 0 0 10 0.72 10 0 0 0 0 0 1 0"
            id="feColorMatrix1"
            result="fbSourceGraphic"
          />
          <feColorMatrix
            result="fbSourceGraphicAlpha"
            in="fbSourceGraphic"
            values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
            id="feColorMatrix3"
          />
          <feColorMatrix
            id="feColorMatrix4"
            values="10 0.72 10 0 0 10 0.72 10 0 0 10 0.72 10 0 0 0 0 0 1 0"
            in="fbSourceGraphic"
          />
        </filter>
        <filter
          id="filter1_d"
          x="0"
          y="0"
          width="100"
          height="100"
          filterUnits="userSpaceOnUse"
          style={{
            colorInterpolation: "sRGB",
          }}
        >
          <feColorMatrix
            values="10 0.72 10 0 0 10 0.72 10 0 0 10 0.72 10 0 0 0 0 0 1 0"
            id="feColorMatrix2"
            result="fbSourceGraphic"
          />
          <feColorMatrix
            result="fbSourceGraphicAlpha"
            in="fbSourceGraphic"
            values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
            id="feColorMatrix5"
          />
          <feColorMatrix
            id="feColorMatrix6"
            values="10 0.72 10 0 0 10 0.72 10 0 0 10 0.72 10 0 0 0 0 0 1 0"
            in="fbSourceGraphic"
          />
        </filter>
      </defs>
      <style id="style1">{".st1{fill:#22205f}"}</style>
      <g
        id="Layer_3_2_"
        style={{
          filter: "url(#filter2)",
        }}
        transform="translate(0 -.2)"
      >
        <g id="Layer_2_1_">
          <path id="Layer_3" d="M0 .2h150v150H0Z" fill="none" />
        </g>
      </g>
      <g
        id="Queen_Mary_University"
        style={{
          filter: "url(#filter1)",
        }}
        transform="translate(0 -.2)"
      >
        <path
          id="path314"
          className={classes.path}
          d="M75.8 113.5c-14.5 0-26.2-14.5-26.2-32.3 0-17.8 11.7-32.3 26.2-32.3S102 63.4 102 81.2c0 17.8-11.8 32.3-26.2 32.3m-.3-67.1C56 46.4 40.2 62 40.2 81.3c0 19.3 15.8 34.9 35.3 34.9 19.5 0 35.3-15.6 35.3-34.9 0-19.2-15.8-34.9-35.3-34.9"
        />
        <path
          id="path318"
          className={classes.path}
          d="M75.8 113.5c-14.5 0-26.2-14.5-26.2-32.3 0-17.8 11.7-32.3 26.2-32.3S102 63.4 102 81.2c0 17.8-11.8 32.3-26.2 32.3Zm-.3-67.1C56 46.4 40.2 62 40.2 81.3c0 19.3 15.8 34.9 35.3 34.9 19.5 0 35.3-15.6 35.3-34.9 0-19.2-15.8-34.9-35.3-34.9Z"
        />
        <path
          id="path322"
          className={classes.path}
          d="M1.8 48.9s25.6 18.1 13.9 40c0 0 17.2-23.5 23 9.6 0 0-4.9-7.5-14.5-5.6-8.3 1.6-9.4 8.1-9.4 8.1l-13-52.1"
        />
        <path
          id="path326"
          className={classes.path}
          d="M1.8 48.9s25.6 18.1 13.9 40c0 0 17.2-23.5 23 9.6 0 0-4.9-7.5-14.5-5.6-8.3 1.6-9.4 8.1-9.4 8.1z"
        />
        <path
          id="path330"
          className={classes.path}
          d="M148.2 48.9s-25.6 18.1-13.9 40c0 0-17.2-23.5-23 9.6 0 0 4.9-7.5 14.5-5.6 8.3 1.6 9.4 8.1 9.4 8.1l13-52.1"
        />
        <path
          id="path334"
          className={classes.path}
          d="M148.2 48.9s-25.6 18.1-13.9 40c0 0-17.2-23.5-23 9.6 0 0 4.9-7.5 14.5-5.6 8.3 1.6 9.4 8.1 9.4 8.1z"
        />
        <path
          id="path338"
          className={classes.path}
          d="M42.5 118.1c3.7-1.3 7.3-2.5 11.9-4.2-1.8-1-4.2-3-5.9-4.5-4.5 1.6-8.7 3.2-11.3 4.1-2.6.9-11.3 2.9-14.4-5.6-2.3-6.2 2.1-10.2 6.4-10.2 1.6 0 3.2.6 3.2.8-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-1.7-.9-3-2.2-4-1.8-1.2-4.2-1.9-6.5-1.9-5.2 0-9.7 4.6-10.5 9.9-.9 6 5.7 18.6 25.3 11.6"
        />
        <path
          id="path342"
          className={classes.path}
          d="M42.5 118.1c3.7-1.3 7.3-2.5 11.9-4.2-1.8-1-4.2-3-5.9-4.5-4.5 1.6-8.7 3.2-11.3 4.1-2.6.9-11.3 2.9-14.4-5.6-2.3-6.2 2.1-10.2 6.4-10.2 1.6 0 3.2.6 3.2.8-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-1.7-.9-3-2.2-4-1.8-1.2-4.2-1.9-6.5-1.9-5.2 0-9.7 4.6-10.5 9.9-.9 6 5.7 18.6 25.3 11.6z"
        />
        <path
          id="path346"
          className={classes.path}
          d="M22.1 128.2c-.8-2.8 2.2-5 6.7-5H123c4.5 0 7.5 2.3 6.7 5-.8 2.8-5.1 4.7-9.5 4.4l-36.3-2.7c-4.4-.3-11.7-.3-16.2 0l-36.1 2.7c-4.4.3-8.7-1.6-9.5-4.4"
        />
        <path
          id="path350"
          className={classes.path}
          d="M22.1 128.2c-.8-2.8 2.2-5 6.7-5H123c4.5 0 7.5 2.3 6.7 5-.8 2.8-5.1 4.7-9.5 4.4l-36.3-2.7c-4.4-.3-11.7-.3-16.2 0l-36.1 2.7c-4.4.3-8.7-1.6-9.5-4.4z"
        />
        <path
          id="path354"
          className={classes.path}
          d="M81.2 43c-3.8-5.5-1.5-8.9 1-8.9 4.1 0 5.6 2.3 5.5 6 2.2-1.3 4.2-4.6 4.2-7.7 0-3.1-2.4-6-5.5-6.1-3.8 0-5.8 1.2-7.5 3.2l.9-1.8c.7-1.3 1.4-2.9 1.4-4.2 0-1.7-.8-3.5-1.9-5.5-1.1-1.9-2.6-4.8-3.6-7.3-1 2.5-2.5 5.4-3.5 7.3-1.1 2-1.9 3.9-1.9 5.5 0 1.4.8 2.9 1.5 4.2.3.6.6 1.2.9 1.9-1.8-2.1-3.7-3.3-7.6-3.3-3.1 0-5.6 2.9-5.5 6.1 0 3.1 2 6.5 4.2 7.7 0-3.7 1.5-6 5.5-6 2.6 0 4.8 3.1.8 8.9 4.4-1.1 6.9-.9 11.1 0"
        />
        <path
          id="path358"
          className={classes.path}
          d="M81.2 43c-3.8-5.5-1.5-8.9 1-8.9 4.1 0 5.6 2.3 5.5 6 2.2-1.3 4.2-4.6 4.2-7.7 0-3.1-2.4-6-5.5-6.1-3.8 0-5.8 1.2-7.5 3.2l.9-1.8c.7-1.3 1.4-2.9 1.4-4.2 0-1.7-.8-3.5-1.9-5.5-1.1-1.9-2.6-4.8-3.6-7.3-1 2.5-2.5 5.4-3.5 7.3-1.1 2-1.9 3.9-1.9 5.5 0 1.4.8 2.9 1.5 4.2.3.6.6 1.2.9 1.9-1.8-2.1-3.7-3.3-7.6-3.3-3.1 0-5.6 2.9-5.5 6.1 0 3.1 2 6.5 4.2 7.7 0-3.7 1.5-6 5.5-6 2.6 0 4.8 3.1.8 8.9 4.4-1.1 6.9-.9 11.1 0z"
        />
        <path
          id="path362"
          className={classes.path}
          d="M133 107c-.7-5.3-5.3-9.9-10.5-9.9-2.3 0-4.8.7-6.5 1.9-1.3 1-2.2 2.3-2.2 4 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c0-.2 1.6-.8 3.2-.8 4.3 0 8.7 4 6.4 10.2-3.1 8.5-11.8 6.5-14.4 5.6-2.6-.9-14.4-5.4-18.9-7l-.2.2c-10.8-3.9-12.5-4.5-17.7-5.6-16.6-3.4-17.7 7.6-17.7 7.6 0 .4 1.4-4.9 12.4-3.7 4.5.5 7.2 1.7 17.5 6l-.1.1c4.6 1.8 15.7 5.8 19.5 7.1 19.4 6.9 26-5.7 25.2-11.7"
        />
        <path
          id="path366"
          className={classes.path}
          d="M133 107c-.7-5.3-5.3-9.9-10.5-9.9-2.3 0-4.8.7-6.5 1.9-1.3 1-2.2 2.3-2.2 4 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c0-.2 1.6-.8 3.2-.8 4.3 0 8.7 4 6.4 10.2-3.1 8.5-11.8 6.5-14.4 5.6-2.6-.9-14.4-5.4-18.9-7l-.2.2c-10.8-3.9-12.5-4.5-17.7-5.6-16.6-3.4-17.7 7.6-17.7 7.6 0 .4 1.4-4.9 12.4-3.7 4.5.5 7.2 1.7 17.5 6l-.1.1c4.6 1.8 15.7 5.8 19.5 7.1 19.4 6.9 26-5.7 25.2-11.7z"
        />
      </g>
    </svg>
  );
};

export default LogoIcon;
